var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLikeTrue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#147AFF",
    style: {
      fill: "#147AFF",
      fill: "color(display-p3 0.0784 0.4784 1.0000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_b_3549_45132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.75 9.75C6.75 9.33579 7.08579 9 7.5 9H9.75V17.25H7.5C7.08579 17.25 6.75 16.9142 6.75 16.5V9.75Z",
    fill: "white",
    style: {
      fill: "white",
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_3549_45132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.75 9.00451L12.6365 5.60866C12.7085 5.52393 12.8141 5.4751 12.9253 5.4751C13.9518 5.4751 14.6817 6.47377 14.3699 7.45181L13.875 9.00451H17.25C17.6642 9.00451 18 9.3403 18 9.75451V12.7501C18 15.2354 15.9853 17.2501 13.5 17.2501H9.75V9.00451Z",
    fill: "white",
    style: {
      fill: "white",
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3986 8.85266L13.1908 9.50451H13.875H17.25C17.3881 9.50451 17.5 9.61644 17.5 9.75451V12.7501C17.5 14.9592 15.7091 16.7501 13.5 16.7501H10.25V9.1883L12.98 5.97652C13.639 6.01086 14.0969 6.66196 13.8935 7.29997L13.3986 8.85266Z",
    stroke: "white",
    style: {
      stroke: "white",
      stroke: "white",
      strokeOpacity: 1
    }
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_3549_45132",
    x: 3.75,
    y: 6,
    width: 9,
    height: 14.25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_3549_45132"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_3549_45132",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_3549_45132",
    x: 6.75,
    y: 2.4751,
    width: 14.25,
    height: 17.7749,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_3549_45132"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_3549_45132",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeTrue);
export default __webpack_public_path__ + "static/media/likeTrue.970f99090906c0b0d438a4e60632bfcc.svg";
export { ForwardRef as ReactComponent };